import { useEffect, useState } from "react";
import axios from "axios";
import StudentsTable from "./Table/studentTable";

import { ChatState } from "../../Context/ChatProvider";
import "./style.css";
import { Button, Divider, useToast } from "@chakra-ui/react";
import Student_crud from "./student/studentForm";
import Payement_crud from "./payement/payementForm";
import PayementTable from "./Table/payementTable";
import StudentsRestPayement from "./Table/studentsRestPayement";



function Payement() {
	const [fetchAgain, setFetchAgain] = useState(false);
	const [fetchHistoryAgain, setFetchHistoryAgain] = useState(false);
	const [action, setAction] = useState(0);
	const toast = useToast();
	const [obj, setObj] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(false);

	const {
		user,
	} = ChatState();

	// useEffect(() => {
	// 	getAllStudents();

	// }, [fetchAgain === true]);

	useEffect(() => {
		if (studentId !== '' && fetchHistoryAgain === true) {


			getHistoryPayement();
			if (action === 2) {
				fetchStudentsWithRecentPayments()
			}
			else if (action === 1) {
				searchEtudient();
			}

			setFetchHistoryAgain(false)
		}
	}, [fetchHistoryAgain]);


	const [studentId, setStudentId] = useState("")
	const [studentName, setStudentName] = useState();
	const [studentsWithRecentPayments, setStudentsWithRecentPayments] = useState();
	const [student, setStudent] = useState([])


	useEffect(() => {
		if (studentId === '') {
			setStudent([]);
			setStudentName();
			setStudentsWithRecentPayments();
			setObj([])
			setAction(0)

		}
	}, [studentId]);


	async function fetchStudentsWithRecentPayments() {
		try {

			setStudentId('')
			setStudentsWithRecentPayments()

			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},

			};
			const { data } = await axios.get(`/api/payement/students/fetch`, config)
			setAction(2)
			setStudentsWithRecentPayments(data)



		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}

	};

	async function getHistoryPayement(name = '') {

		try {
			if (studentId != '') {

				setObj([])

				setLoading(true);
				const config = {
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
					params: { studentId: studentId }
				};
				const { data } = await axios.get(`/api/payement`, config)

				setLoading(false);
				setStudentName(name)
				setObj(data)


			}

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}
		setFetchAgain(false);

	};





	async function searchEtudient() {
		try {
			setAction(1)
			setStudent([])
			setObj([])
			setStudentsWithRecentPayments()

			if (studentId !== '') {
				const config = {
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
					params: { studentId: studentId }
				};
				const { data } = await axios.get(`/api/student`, config)

				setStudent(data)

				// getRestPayementByStudentId()
			}
		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				description: "Échec du chargement des résultats de recherche",
				status: "error",
				duration: 5000,
				isClosable: true,
				position: "bottom-left"
			});
		}
	}


	return (
		<div className=" w-full flex flex-col">



			<div className="py-5">
				<div className="flex items-center justify-between ">


					<div className=" w-fit p-1 border  border-gray-200 rounded-md">
						<input className="h-6 w-40 lg:w-52  mr-3 py-3 px-2  border-none xs:w-20"
							type="text" placeholder="Etudient Id" value={studentId}
							onChange={(e) => setStudentId(e.target.value)} />
						<Button className=" flex items-center align-middle h-20" bg='gray.50' onClick={searchEtudient} ><i className="fa-solid fa-magnifying-glass text-sm mr-2 text-blue-400"></i> <p>Rechercher</p> </Button>
					</div>

					<Button colorScheme='red' _focus={{ boxShadow: "none" }} className="flex items-center align-middle h-30 " onClick={fetchStudentsWithRecentPayments} ><i className="fa-solid fa-file-circle-exclamation  text-xl  lg:mr-2 md:mr-2"></i>
						<p className="hidden lg:block md:block">les Etudients non payée</p> </Button>
				</div>
				<div className="p-4 text-gray-700 w-full  mt-3 drop-shadow-md">
					{action == 1 ? student.map((item, index) => {

						if (student.group) {
							return	<div key={index} className=' border border-gray-300 w-fit px-5 py-2'>
								<h1 className="text-md font-bold border-b pt-4 pb-2"><i className="fa-solid fa-user"></i> {item.name}</h1>
								<div className="text-md font-bold pt-4 pb-2 border-b">
									<p className=" inline-block mr-5"> Niveux :{item.levels}</p>
									<p className="inline-block"> Group :{item.group}</p>
								</div>

								<p className="text-md font-bold py-4"> le reste de paiement : {item.restPayement} Dh</p>
								<Payement_crud Id={studentId} studientName={item.name} level={item.levels} setFetchAgain={setFetchAgain} />
								<Button className="flex items-center align-middle h-20 mt-4 lg:mt-0 md:mt-0 lg:ml-5 md:ml-5" bg='gray.50' onClick={() => getHistoryPayement(item.name)}><i className="fa-solid fa-history mr-2 text-blue-400"></i> <p>Historique des paiements</p>  </Button>

							</div>}
						}) : ''
					}
					{
						action === 2 ? studentsWithRecentPayments ?
							<div className="table_container">
								<StudentsRestPayement data={studentsWithRecentPayments} search={search} loading={loading} setFetchAgain={setFetchAgain} getHistoryPayement={getHistoryPayement} setStudentId={setStudentId} /> </div> : '' : ''
					}
				</div>

			</div>
			<div className="">

				<div className="">
					<div className="table_container">
						<PayementTable data={obj} Id={studentId} name={studentName} search={search} loading={loading} setFetchHistoryAgain={setFetchHistoryAgain} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Payement;
